import React, { Fragment, useContext, useEffect, useState } from "react";
import { Breadcrumb, Loader } from "semantic-ui-react";
import { useStorage } from '../../hook/useStorage';
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { Context } from "../../../context/globalContext";
import { getUser } from "../../auth/services";
import Experiences from '../components/Experiences'
import ProfileInfo from '../components/ProfileInfo'
import { GApageView } from "../..";

const ExperiencesScreen = () => {
    let { username: paramUsermane } = useParams();
    const [loadingUserSearchProfile, setLoadingUserSearchProfile] = useState(
        true
    );
    const [userSearchProfile, setUserSearchProfile] = useState({});

    const {
        graphQLClient,
        state: { user: userProfile },
    } = useContext(Context);

    useEffect(() => {
        GApageView("Experiences");
      }, []);

    useEffect(() => {
        setLoadingUserSearchProfile(true);
        if (paramUsermane !== userProfile.username) {
            getUserSearchProfile(paramUsermane);
        } else {
            setUserSearchProfile(userProfile);
            setLoadingUserSearchProfile(false);
        }
    }, [paramUsermane, userProfile]);

    async function getUserSearchProfile(username) {
        const userData = await getUser(graphQLClient, "", username);
        setUserSearchProfile({
            ...userData?.userFirestore,
            ...userData?.userAccount,
        });
        setLoadingUserSearchProfile(false);
    }

    const image = useStorage(`avatars/${userProfile.avatar}`);
    return (
        <section id="page_content">
            <BackgroundGrey>

                <BreadcrumbContainer>
                    <Breadcrumb icon="right angle">
                        <Breadcrumb.Section link>Home</Breadcrumb.Section>
                        <Breadcrumb.Divider />
                        <Breadcrumb.Section link>Experiences</Breadcrumb.Section>
                        <Breadcrumb.Divider />
                        <Breadcrumb.Section active>
                            {userProfile.username}
                        </Breadcrumb.Section>
                    </Breadcrumb>
                </BreadcrumbContainer>
            </BackgroundGrey>
            <BackgroundGrey>
                <Container>
                    <ProfileInfo
                        userProfile={userProfile}
                        image={image}
                    />
                </Container>
            </BackgroundGrey>
            <Container>
                <Experiences />
            </Container>
        </section>
    )

}

export default ExperiencesScreen;
const BreadcrumbContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 16px 32px;
`;
const BackgroundGrey = styled.div`
  background-color: #f5f5f5;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 8px 32px 32px 32px;
`;
